<div class="relatedstory" *ngIf="story">
  <label *ngIf="!alsoRead" type="text" class="textBox" [innerHTML]="story.mobileHeadline"></label>
  <ng-container *ngIf="alsoRead">
    <label *ngIf="!editFlag" type="text" class="textBox" [innerHTML]="headline ? headline : story.mobileHeadline"></label>
    <input *ngIf="editFlag" class="textBox" type="text" 
    (keydown)="saveHeadline($event)"  [(ngModel)]="newHeading"  />
  </ng-container>
  <span *ngIf="editMode" #opts2 class="threedots" (click)="showOptions = !showOptions"><span></span><span></span><span></span></span>
  <div class="revertStoryBlock" #opts [style.display]="showOptions ? 'block': 'none'">
    <ul *ngIf="showOptions">
      <li>
        <button *ngIf="!alsoRead" (click)="triggerReplace()">Replace</button>
      </li>
      <li>
        <button (click)="triggerDelete()">Delete</button>
      </li>
      <li *ngIf="alsoRead">
        <button (click)="triggerEdit()">Edit Headline</button>
      </li>
    </ul>
  </div>
</div>
